<template>
  <page>
    <div>
      <v-card>
        <form>
          <message :messages="messages"></message>
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-text-field
                            v-model="form.acctYearFrom"
                            :label="label.acctYearFrom"
                            :error-messages="errors.collect('acctYearFrom')"
                            data-vv-name="acctYearFrom"
                            :data-vv-as="label.acctYearFrom"
                            :loading="loading"
                            @change="getGlYrCloseCtrlFrom($event)"
                            v-validate="acctYearFromValidation"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="form.acctYearTo"
                            :label="label.acctYearTo"
                            :error-messages="errors.collect('acctYearTo')"
                            data-vv-name="acctYearTo"
                            :data-vv-as="label.acctYearTo"
                            :loading="loading"
                            @change="getGlYrCloseCtrlTo($event)"
                            v-validate="acctYearToValidation"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-autocomplete
                            :items="tranferBudgets"
                            v-model="form.transferBudget"
                            :label="label.transferBudget"
                            item-text="label"
                            item-value="value"
                            data-vv-name="transferBudget"
                            :data-vv-as="label.transferBudget"
                            :error-messages="errors.collect('transferBudget')"
                            v-validate="'required'"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs6></v-flex>
                        <v-flex lg12 sm12 xs12>
                          <v-text-field
                            v-model="form.branch"
                            :label="label.branch"
                            :error-messages="errors.collect('branch')"
                            data-vv-name="branch"
                            :data-vv-as="label.branch"
                            append-icon="mdi-magnify"
                            @click:append="getHelpList('branch')"
                            v-validate="'required'"
                            readonly
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-container fluid grid-list-lg>
                      <v-btn class="mr-2" color="error" dark @click.prevent="doCancel">
                        {{ label.cancel }}
                        <v-icon right dark>mdi-close-circle</v-icon>
                      </v-btn>
                      <v-btn class="mr-2" color="info" dark @click="doSchedule">
                        {{ label.schedule }}
                        <v-icon right dark>mdi-clock</v-icon>
                      </v-btn>
                      <v-btn color="primary" dark type="submit" @click.prevent="doExport">
                        {{ label.submit }}
                        <v-icon right dark>mdi-check</v-icon>
                      </v-btn>
                    </v-container>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
        <v-dialog v-model="processingFlag" persistent width="300">
          <v-card color="primary" dark>
            <v-card-text>
              Processing...
              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="helplist" width="900px" persistent>
          <helplist :apiURI="apiURI" :mode="mode" :param="param" @close="doClose" @doAssign="doAssign($event)"></helplist>
        </v-dialog>
        <v-dialog v-model="scheduleJobModal" width="1000px" persistent>
          <ScheduleJob @close="scheduleJobModal = false" :jobName="jobName" :jobDesc="jobDesc"></ScheduleJob>
        </v-dialog>
      </v-card>
    </div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import Helplist from '../Helplist'
import ScheduleJob from '@/components/core/common/dialog/ScheduleJob'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      label: {
        transferBudget: 'Transfer Budget',
        branch: 'Branch',
        acctYearFrom: 'Accounting Year From',
        acctYearTo: 'Accounting Year To',
        submit: 'Submit',
        schedule: 'Schedule',
        cancel: 'Cancel'
      },
      form: {
        transferBudget: 'N',
        branch: 'All',
        acctYearFrom: '',
        acctYearTo: '',
        cRunProg: 'Start'
      },
      tranferBudgets: [
        { label: 'No', value: 'N' },
        { label: 'Original Budget', value: 'O' },
        { label: 'Revised Budget', value: 'R' }
      ],
      supportedFormat: [],
      submitting: false,
      menu: {},
      helplist: false,
      apiURI: '',
      mode: '',
      param: '',
      toggleFilters: [true],
      defAcctYr: '',
      isClosed: false,
      scheduleJobModal: false,
      isClosedFrom: false,
      jobName: 'qrtzStartNewFinancialYear',
      jobDesc: 'Start New Financial Year',
      loading: false,
      processingFlag: false,
      panel: [0]
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('glManagementInit')])
      await Promise.all([this.$store.dispatch('financialYearInit')])
      this.getCompany()
    },
    getHelpList(fieldName) {
      this.mode = fieldName
      if (fieldName === 'branch') {
        this.apiURI = this.$store.state.generalLedger.financialYear.menu.branchList
        this.param = this.form.branch
      }
      this.helplist = true
    },
    doAssign(Obj) {
      switch (this.mode) {
        case 'branch':
          this.form.branch = ''
          this.form.branch = Obj.finalSelectedItems.toString()
          break
      }
    },
    doClose() {
      this.helplist = false
    },
    async getCompany() {
      const apiURI = this.$store.state.generalLedger.financialYear.menu.getCompany
      if (apiURI) {
        this.loading = true
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.form.acctYearFrom = data.company.currAcctYr
          this.form.acctYearTo = data.company.currAcctYr + 1
          this.defAcctYr = data.company.currAcctYr
          this.loading = false
        }
      }
    },
    async getGlYrCloseCtrlFrom(currAcctYr) {
      const apiURI = this.$store.state.generalLedger.financialYear.menu.getGLYrCloseCtrl
      if (apiURI) {
        this.loading = true
        const expand = {
          acctYr: currAcctYr
        }
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (data) {
          this.loading = false
          this.isClosedFrom = data.glYrCloseCtrl.closed
        } else {
          this.loading = false
          this.isClosedFrom = false
        }
      }
    },
    async getGlYrCloseCtrlTo(currAcctYr) {
      const apiURI = this.$store.state.generalLedger.financialYear.menu.getGLYrCloseCtrl
      if (apiURI) {
        this.loading = true
        const expand = {
          acctYr: currAcctYr
        }
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (data) {
          this.loading = false
          this.isClosed = data.glYrCloseCtrl.closed
        } else {
          this.loading = false
          this.isClosed = false
        }
      }
    },
    doSchedule() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.scheduleJob()
        }
      })
    },
    scheduleJob() {
      this.scheduleJobModal = true
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.$store.state.generalLedger.financialYear.menu.generateXferBal
      if (apiURI) {
        this.processingFlag = true
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
          this.processingFlag = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
          this.processingFlag = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doCancel() {
      this.$router.go(-1)
    }
  },
  created() {
    this.doInit()
    this.$validator.extend('acctYrFromDate', {
      getMessage(field, args) {
        return 'Must be Current Accounting Year or future year.'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var currAcctYear = args[0]
        if (parseInt(currAcctYear) > parseInt(value)) {
          return false
        } else {
          return true
        }
      }
    })

    this.$validator.extend('acctYrToDate', {
      getMessage(field, args) {
        return 'Accounting Year To must be equal or greater than Accounting Year From'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var acctYrFrom = args[0]
        if (parseInt(acctYrFrom) > parseInt(value)) {
          return false
        } else {
          return true
        }
      }
    })

    this.$validator.extend('maxAcctYrFromDate', {
      getMessage(field, args) {
        return 'Accounting Year From must be Current Accounting Year or future year'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var acctYrFrom = args[0]
        if (parseInt(value) < parseInt(acctYrFrom)) {
          return false
        } else {
          return true
        }
      }
    })

    this.$validator.extend('maxAcctYrToDate', {
      getMessage(field, args) {
        return 'Accounting Year To cannot be more than 1 year of Accounting Year From'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var acctYrTo = args[0]
        if (parseInt(value) - parseInt(acctYrTo) > 1) {
          return false
        } else {
          return true
        }
      }
    })

    this.$validator.extend('isClosedDateFrom', {
      getMessage(field, args) {
        return 'Financial Year is closed'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var closed = args[0]
        if (closed === 'true') {
          return false
        } else {
          return true
        }
      }
    })

    this.$validator.extend('isClosedDateTo', {
      getMessage(field, args) {
        return 'Accounting Year is closed'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var closed = args[0]
        if (closed === 'true') {
          return false
        } else {
          return true
        }
      }
    })
  },
  computed: {
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    acctYearFromValidation() {
      if (this.form.acctYearFrom !== '') {
        return 'entry|numeric|max:4|acctYrFromDate:' + parseInt(this.defAcctYr)
      } else {
        return 'required'
      }
    },
    acctYearToValidation() {
      if (this.form.acctYearTo !== '') {
        return (
          'entry|numeric|max:4|acctYrToDate:' +
          this.form.acctYearFrom +
          '|maxAcctYrToDate:' +
          parseInt(this.form.acctYearFrom) +
          '|isClosedDateTo:' +
          this.isClosed
        )
      } else {
        return 'required'
      }
    }
  },
  watch: {
    supportedList: function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.form.format = value[0].value
      }
    }
  },
  mixins: [MessageMixin],
  components: {
    ScheduleJob,
    Helplist
  }
}
</script>
